<template>
	<div class="row">
		<div class="col-md-8 col-xl-9">
			<b-card :title="title">
				<hr style="margin-left: -1.7rem;margin-right: -1.7rem;" />
				<b-overlay id="overlay-background" :show="loading" opacity="0.6" style="width: 100%;"
					spinner-variant="primary">
					<div class="row" style="padding-top: 1rem;">
						<div class="col-xl-9">
							<b-form-group v-if="app.id" label-cols-sm="2" label-cols-xl="2" label-align-sm="right"
								label="应用ID:" label-for="id">
								<b-form-input id="id" v-model="app.id" trim placeholder="应用ID" readonly></b-form-input>
							</b-form-group>
							<b-form-group label-cols-sm="2" label-cols-xl="2" label-align-sm="right" label="应用名称:"
								label-for="name">
								<b-form-input id="name" v-model="app.name" trim placeholder="请填写应用名称"></b-form-input>
							</b-form-group>
							<b-form-group label-cols-sm="2" label-cols-xl="2" label-align-sm="right" label="应用描述:"
								label-for="detail">
								<b-form-input id="detail" v-model="app.detail" trim placeholder="请填写应用描述">
								</b-form-input>
							</b-form-group>
							<b-form-group label-cols-sm="2" label-cols-xl="2" label-align-sm="right" label="应用状态:"
								label-for="state">
								<b-form-checkbox class="cus_form_box" id="state" v-model="app.state" name="check-button"
									switch>
									<b> {{ app.state?"已启用":"已禁用" }}</b>
								</b-form-checkbox>
							</b-form-group>
							<b-form-group label-cols-sm="2" label-cols-xl="2" label-align-sm="right" label="应用秘钥:"
								label-for="secret">
								<div class="cus_form_box" style="display: flex;justify-content: space-between;">
									<div v-if="secretStatus" class="secret_text">{{app.secret}}</div>
									<div v-if="!secretStatus" class="secret_text"><span
											v-for="item in app.secret">*</span>
									</div>
									<div>
										<feather-icon v-if="secretStatus" class="secret_icon" size="16"
											icon="EyeOffIcon" @click="showSecret(false)" />
										<feather-icon v-if="!secretStatus" class="secret_icon" size="16" icon="EyeIcon"
											@click="showSecret(true)" />
										<feather-icon class="secret_icon copy" size="16" icon="CopyIcon"
											:data-clipboard-text="app.secret" @click="copySecret" />
										<feather-icon class="secret_icon" size="16" icon="RefreshCcwIcon"
											@click="refreshSecret" />
									</div>
								</div>
							</b-form-group>
							<b-form-group label-cols-sm="2" label-cols-xl="2" label-align-sm="right" label="可信域名:"
								label-for="domains">
								<div v-for="(item,index) in app.domains" class="domain_box">
									<b-form-input id="domains" v-model="item.value" trim
										placeholder="请填写HTTP/HTTPS URL">
									</b-form-input>
									<b-button variant="danger" class="domain_btn" @click="deleteItem('domain',item)">
										<span>删除</span>
									</b-button>
								</div>
								<b-button variant="primary" @click="addItem('domain')">
									<span>+ 添加</span>
								</b-button>
							</b-form-group>
							<b-form-group label-cols-sm="2" label-cols-xl="2" label-align-sm="right" label="校验IP白名单:"
								label-for="check_ip_whitelist">
								<b-form-checkbox class="cus_form_box" id="check_ip_whitelist" v-model="app.check_ip_whitelist_state" name="check-button"
									switch>
									<!-- <b> {{ app.check_ip_whitelist_state?"开启":"关闭" }}</b> -->
								</b-form-checkbox>
							</b-form-group>
							<b-form-group v-if="app.check_ip_whitelist_state" label-cols-sm="2" label-cols-xl="2" label-align-sm="right" label="IP白名单:"
								label-for="ips">
								<div v-for="(item,index) in app.ips" class="domain_box">
									<b-form-input id="ips" v-model="item.value" trim placeholder="请填写有效的IP">
									</b-form-input>
									<b-button variant="danger" class="domain_btn" @click="deleteItem('ip',item)">
										<span>删除</span>
									</b-button>
								</div>
								<b-button variant="primary" @click="addItem('ip')">
									<span>+ 添加</span>
								</b-button>
							</b-form-group>
						</div>
					</div>
				</b-overlay>
			</b-card>
		</div>
		<div class="col-md-4 col-xl-3">
			<b-card>
				<b-button block variant="primary" @click="save" :disabled="loading">
					<b-spinner small v-if="loading" style="margin-right: .5rem;position: relative; top:-.1rem;" />
					<span class="text-nowrap">保存</span>
				</b-button>
				<b-button block variant="outline-secondary" @click="quxiao">
					<span>取消</span>
				</b-button>
			</b-card>
		</div>
	</div>
</template>

<script>
	import {
		BCard,
		BButton,
		BFormGroup,
		BFormInput,
		BFormCheckbox,
		BIcon,
		BOverlay,
		BSpinner,
	} from 'bootstrap-vue'
	import Clipboard from 'clipboard';

	export default {
		components: {
			BCard,
			BButton,
			BFormGroup,
			BFormInput,
			BFormCheckbox,
			BIcon,
			BOverlay,
			BSpinner,
		},
		data() {
			return {
				title: "添加应用",
				loading: false,
				id: undefined,
				secretStatus: false,
				app: {
					secret: "",
					domains: [{
						id: "1"
					}],
					ips: [{
						id: "1"
					}],
					state: true,
					check_ip_whitelist_state:true,
				}
			}
		},
		created() {
			this.app.id = this.$route.params.id;
			if (this.app.id) {
				this.title = "修改应用"
				this.loading = true
				this.$http.get("/App/GetApp", {
					params: {
						id: this.app.id
					}
				}).then(u => {
					this.loading = false
					u.domains = JSON.parse(u.domain_list).map((value, index) => {
						return {
							id: index.toString(),
							value: value
						}
					})
					u.ips = JSON.parse(u.ip_white_list).map((value, index) => {
						return {
							id: index.toString(),
							value: value
						}
					})
					u.state = u.status == 1;
					u.check_ip_whitelist_state = u.check_ip_whitelist == 1;
					this.app = u;
				}).catch(u => {
					this.loading = false
				})
			} else {
				this.app.secret = this.$guid2()
			}
		},
		methods: {
			addItem(type) {
				if (type == 'domain') {
					this.app.domains.push({
						id: (this.app.domains.length + 1).toString()
					})
				} else {
					this.app.ips.push({
						id: (this.app.ips.length + 1).toString()
					})
				}
			},
			deleteItem(type, item) {
				if (type == 'domain') {
					if (this.app.domains.length <= 1) {
						this.$alertError('请至少输入一个可信域名');
						return;
					}
					this.app.domains = this.app.domains.filter(u => u.id != item.id)
				} else {
					if (this.app.ips.length <= 1) {
						this.$alertError('请至少输入一个IP');
						return;
					}
					this.app.ips = this.app.ips.filter(u => u.id != item.id)
				}
			},
			operate(data) {
				var id = data && data.item ? data.item.id : undefined;
				this.$router.push({
					name: 'AppEdit',
					params: {
						id
					}
				});
			},
			quxiao() {
				this.$router.go(-1)
			},
			showSecret(show) {
				if (show) {
					this.secretStatus = true
				} else {
					this.secretStatus = false
				}
			},
			copySecret() {
				let clipboard = new Clipboard(".copy");
				clipboard.on("success", e => {
					this.$successAlert("", "复制成功")
					clipboard.destroy();
				});
				clipboard.on("error", e => {
					this.$errorAlert("请手动复制", "复制失败")
					clipboard.destroy();
				});
			},
			refreshSecret() {
				this.$confirm("重置秘钥将使旧的秘钥失效，是否重置？").then(u => {
					this.app.secret = this.$guid2()
					this.$successAlert("保存后生效", "重置秘钥成功")
				})
			},
			save() {
				if (this.app.name === "" || this.app.name === undefined) {
					this.$alertError('请输入应用名称');
					return;
				}
				if (this.app.secret === "" || this.app.secret === undefined) {
					this.$alertError('请输入应用名称');
					return;
				}
				if (this.app.check_ip_whitelist_state && this.app.ips.filter(u => u.value).length <= 0) {
					this.$alertError('请至少输入一个IP');
					return;
				} 
				this.app.status = this.app.state ? 1 : 0
				this.app.check_ip_whitelist = this.app.check_ip_whitelist_state ? 1 : 0
				this.app.ips = this.app.ips.filter(u => u.value)
				this.loading = true
				this.$http.post(this.app.id ? "/App/UpdateApp" : "/App/InsertApp", this.app).then(u => {
					this.loading = false
					if (this.app.id) {
						this.$alertSuccess('修改应用成功');
					} else {
						this.$alertSuccess('创建应用成功');
					}
					this.$router.go(-1)
				}).catch(u => {
					this.loading = false
					console.log(u.response)
				})
			}
		},
	}
</script>

<style>
	.domain_box {
		display: flex;
		margin-bottom: .6rem;
	}

	.domain_btn {
		width: 6.5rem;
		margin-left: 1rem;
	}

	.form-group label {
		font-size: 1rem;
	}

	.cus_form_box {
		position: relative;
		top: .5rem;
	}

	.secret_text {
		font-size: 1.2rem;
	}

	.secret_icon {
		margin-left: .8rem;
		cursor: pointer;
	}
</style>